import * as yup from 'yup'

const PolicyDurationSchema = yup.object().shape({
  duration: yup.number().required('Please select a duration'),
  durationType: yup.string().required('Please select a valid duration type'),
})

export default PolicyDurationSchema
